export const UPDATE_MY_PAGE_REQUEST = 'UPDATE_MY_PAGE_REQUEST'
export const UPDATE_MY_PAGE_FAILED = 'UPDATE_MY_PAGE_FAILED'
export const UPDATE_MY_PAGE_SUCCESS = 'UPDATE_MY_PAGE_SUCCESS'
export const GET_MY_PAGE_REQUEST = 'GET_MY_PAGE_REQUEST'
export const GET_MY_PAGE_FAILED = 'GET_MY_PAGE_FAILED'
export const GET_MY_PAGE_SUCCESS = 'GET_MY_PAGE_SUCCESS'
export const CLEAR_MY_PAGE = 'CLEAR_MY_PAGE'
